import React from "react";
import { DispatchProp } from "react-redux";
import { ChoiceModel } from "../../models/ChoiceModel";
import { MentionModel } from "../../models/MentionModel";
import { QuestionModel } from "../../models/QuestionModel";
import { MentionBuilderDelegate } from "../../models/builders/MentionBuilder";
import { QuestionnaireModel } from "../../models/QuestionnaireModel";
import { ThemeModel } from "../../models/ThemeModel";
import { VariableModel } from "../../models/VariableModel";
import { setVariableMentions } from "../../redux/actions";

export interface ChoiceHandler {
    select(): void;
}

export type ChoiceRef = React.MutableRefObject<ChoiceHandler>;

export interface ChoiceProps {
    // Store state
    question: QuestionModel;
    questionnaire: QuestionnaireModel;
    mentions: MentionModel[];
    theme: ThemeModel;
    language: string;
    matrix: number;
    // Props
    choice: ChoiceModel;
    choiceRef: ChoiceRef;
    variable: VariableModel;
    gridRendering?: boolean;
    openEnd?: string;
    isFirst?: boolean;
    isLast?: boolean;
    horizontal?: boolean;
    label?: string;
    isDisabled?: boolean;
    isSelected?: boolean;
}

export abstract class BaseChoice<P, S> extends React.Component<P & ChoiceProps & DispatchProp, S> {
    setMentions(variableName: string, builder: MentionBuilderDelegate, matrixIndex?: number) {
        const { matrix, dispatch } = this.props;
        const index = matrixIndex || matrix;
        dispatch(setVariableMentions(variableName, builder, index));
    }

    getMention = (mentionIndex?: number) => {
        const { mentions } = this.props;
        return mentions[mentionIndex || 0];
    };

    getMentionValues = () => {
        const { mentions } = this.props;
        return mentions.map((m) => m.value);
    };

    getMentionValue = (mentionIndex?: number) =>
        this.getMention(mentionIndex) === undefined ? "" : this.getMention(mentionIndex).value;

    getMentionOpenEnd = (mentionIndex?: number) =>
        this.getMention(mentionIndex) === undefined ? "" : this.getMention(mentionIndex).openEnd;

    abstract renderChoice(choice: ChoiceModel);

    render() {
        const { choice } = this.props;
        return this.renderChoice(choice);
    }
}
